/**
* Image Content Mix JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Content Mix component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'image-content-mix',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      // $( '.image-content-mix' ).each( function( key, val ) {
      //   const leftImage = $( this ).find( '.left-image .fit-image img' )[0];
      //   const bottomImage = $( this ).find( '.bottom-image .fit-image img' )[0];
      //   const rightImage = $( this ).find( '.right-image .fit-image img' )[0];
      //   const height = $( this ).outerHeight();

      //   if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
      //     const tl = gsap.timeline( {
      //       scrollTrigger: {
      //         trigger: this,
      //         start: 'top 75%',
      //         end: 'bottom 25%',
      //         scrub: 0,
      //       },
      //     } );
      //     tl.to( leftImage, {y: '-25%', ease: 'linear'}, 0 );
      //     tl.to( bottomImage, {y: '65%', ease: 'linear'}, 0 );
      //     tl.to( rightImage, {x: '-15%', ease: 'linear'}, 0 );
      //   }
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-content-mix', COMPONENT );
} )( app );
